import store from '@/state/store';
import { remove } from '@/api/project';
import projectSlice from '@/state/project.slice';
import { handleError } from '@/actions/common';

export default async (code: string): Promise<void> => {
  try {
    await remove(code);
    store.dispatch(projectSlice.actions.removeProject(code));
  } catch (error) {
    handleError(error);
  }
};
